import styled, { css } from 'styled-components';
import { ListingRead } from '../../../lib/api/generated';
import { globalTheme } from '../../../styles/global-theme';
import { Text } from '../text';

const TextData = styled(Text)<{ flex?: boolean; isMobile?: boolean }>`
  font-size: unset;
  ${({ isMobile, flex }) =>
    flex &&
    css`
      display: flex;
      align-items: ${isMobile ? 'start' : 'center'};
      flex-direction: ${isMobile ? 'column' : 'row'};
      gap: ${isMobile ? '4px' : globalTheme.space[0]};
      ${globalTheme.space[0]};
    `};
`;

export interface ExpectedWeightProps {
  weightMin: Pick<ListingRead, 'form_data'> | undefined;
  weightAvg: Pick<ListingRead, 'form_data'> | undefined;
  weightMax: Pick<ListingRead, 'form_data'> | undefined;
}
export const ExpectedWeight = ({
  weightMin,
  weightAvg,
  weightMax,
}: ExpectedWeightProps) => {
  return (
    <TextData data-pdf='value-p' as={'span'}>
      {weightMin && weightMax && weightAvg && (
        <>
          Avg {weightAvg}kg (range: {weightMin} - {weightMax}kg)
        </>
      )}
      {weightMin && weightAvg && !weightMax && (
        <>
          Avg {weightAvg}kg (min: {weightMin}kg)
        </>
      )}
      {weightAvg && weightMax && !weightMin && (
        <>
          Avg {weightAvg}kg (max: {weightMax}kg)
        </>
      )}
      {!weightAvg && !weightMax && weightMin && <>Min {weightMin}kg</>}
      {!weightAvg && weightMax && !weightMin && <>Max {weightMax}kg</>}
      {weightAvg && !weightMax && !weightMin && <>Avg {weightAvg}kg</>}
      {!weightAvg && !weightMax && !weightMin && (
        <>No weight estimates provided</>
      )}
      {!weightAvg && weightMax && weightMin && weightMax !== weightMin && (
        <>
          {weightMin}kg - {weightMax}kg
        </>
      )}
      {!weightAvg && weightMax && weightMin && weightMax === weightMin && (
        <>{weightMax}kg</>
      )}
    </TextData>
  );
};

export const getWeightValue = ({
  weightMin,
  weightAvg,
  weightMax,
}: ExpectedWeightProps): string => {
  let result = '';

  if (weightMin && weightMax && weightAvg) {
    result += `Avg ${weightAvg}kg (range: ${weightMin} - ${weightMax}kg)`;
  } else if (weightMin && weightAvg && !weightMax) {
    result += `Avg ${weightAvg}kg (min: ${weightMin}kg)`;
  } else if (weightAvg && weightMax && !weightMin) {
    result += `Avg ${weightAvg}kg (max: ${weightMax}kg)`;
  } else if (!weightAvg && !weightMax && weightMin) {
    result += `Min ${weightMin}kg`;
  } else if (!weightAvg && weightMax && !weightMin) {
    result += `Max ${weightMax}kg`;
  } else if (weightAvg && !weightMax && !weightMin) {
    result += `Avg ${weightAvg}kg`;
  } else if (!weightAvg && weightMax && weightMin && weightMax !== weightMin) {
    result += `${weightMin}kg - ${weightMax}kg`;
  } else if (!weightAvg && weightMax && weightMin && weightMax === weightMin) {
    result += `${weightMax}kg`;
  }

  return result;
};
